export default __webpack_public_path__ + "static/media/Center for Creative Leadership.721073fe.png";